import { memo, useMemo } from 'react';
import ReactQuill from 'react-quill';

import cn from 'classnames';

import 'react-quill/dist/quill.snow.css';

interface RichTextEditorProps {
    value: string;
    onChange?: (text: string) => void;
    placeholder?: string;
    className?: string;
    isReadOnly?: boolean;
}

export const RichTextEditor = memo((props: RichTextEditorProps) => {
    const {
        value,
        onChange,
        className,
        placeholder = '',
        isReadOnly = false,
    } = props;

    const modules = useMemo(
        () => ({
            toolbar: isReadOnly
                ? false
                : [
                      ['bold', 'italic', 'underline', 'strike'],
                      [{ list: 'ordered' }, { list: 'bullet' }],
                      ['link', 'image'],
                  ],
        }),
        [isReadOnly],
    );

    const formats = useMemo(
        () => [
            'bold',
            'italic',
            'underline',
            'strike',
            'list',
            'bullet',
            'link',
            'image',
        ],
        [],
    );

    return (
        <ReactQuill
            className={cn(className)}
            formats={formats}
            modules={modules}
            onChange={onChange ?? (() => {})}
            placeholder={placeholder}
            readOnly={isReadOnly}
            theme="snow"
            value={value}
        />
    );
});

RichTextEditor.displayName = 'RichTextEditor';
